import { ICity } from "@types";
import { BaseAPI } from "@utils";

class CitiesApi extends BaseAPI<ICity> {}

export const citiesApi = new CitiesApi("/api/v1/cities");
